// extracted by mini-css-extract-plugin
export default {"fv_area":"Complete_fv_area__eItJT","form_area":"Complete_form_area__7FYpX","submit_button":"Complete_submit_button__Git4n"};